import PropTypes from "prop-types";
import React, { Component } from "react";
import { Card, CardTitle, CardText, DialogContainer } from "react-md";

class SketchImageWrapper extends Component {
    constructor(){
        super();
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.state = {
            visible: false
        };
    }

    show(){
        this.setState({visible: true});
    }

    hide(){
        this.setState({visible: false});    
    }

    render(){
        return (
            <div className="PhotoWrapper">
                <Card 
                    className="md-block-centered" 
                    onClick={this.show} 
                    style={{cursor: "zoom-in", marginRight: "2px"}}>
                    <CardTitle 
                        style={{fontSize: 12}} 
                        title={`Sketch ${this.props.number}`} 
                    />
                    <CardText>
                        <div className="PhotoContainer">
                            <img src={this.props.src + "&" + new Date().getTime()} /> 
                        </div>
                    </CardText>
                </Card>
                <DialogContainer
                    id="sketch-photo-dialog"
                    visible={this.state.visible}
                    title={`Sketch ${this.props.number}`}
                    focusOnMount={false}
                    onHide={this.hide} 
                    height="auto"
                    width="fit-content">  
                    <img width="100%" src={this.props.src + "&" + new Date().getTime()} />        
                </DialogContainer>
            </div>
        );
    }
}

SketchImageWrapper.propTypes = {
    src: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
};

export default SketchImageWrapper;
